<div class="content-area">
    <div class="profile-header-card">
        <div class="avatar-large" [style.background-image]="photoURL ? 'url(' + photoURL + ')' : ''">
            {{ photoURL ? '' : (displayName ? displayName.charAt(0) : 'U') }}
        </div>

        <div class="profile-info" *ngIf="!isEditing">
            <h2>{{ displayName || 'User' }}</h2>
            <p class="email-text">{{ (authService.user$ | async)?.email }}</p>
        </div>

        <div class="profile-edit-form" *ngIf="isEditing">
            <mat-form-field appearance="outline" class="full-width">
                <mat-label>Display Name</mat-label>
                <input matInput [(ngModel)]="displayName" placeholder="Enter name">
            </mat-form-field>

            <mat-form-field appearance="outline" class="full-width">
                <mat-label>Photo URL</mat-label>
                <input matInput [(ngModel)]="photoURL" placeholder="https://example.com/photo.jpg">
                <mat-icon matSuffix>link</mat-icon>
            </mat-form-field>
        </div>

        <div class="action-buttons">
            <button mat-flat-button color="primary" *ngIf="!isEditing" (click)="toggleEdit()">
                <mat-icon>edit</mat-icon> Edit Profile
            </button>

            <ng-container *ngIf="isEditing">
                <button mat-flat-button color="primary" (click)="saveProfile()" [disabled]="isLoading">
                    {{ isLoading ? 'Saving...' : 'Save Changes' }}
                </button>
                <button mat-stroked-button (click)="toggleEdit()">
                    Cancel
                </button>
            </ng-container>
        </div>
    </div>

    <!-- Quick Actions -->
    <mat-card class="section-card">
        <mat-card-header>
            <mat-card-title>Account</mat-card-title>
        </mat-card-header>
        <mat-card-content>
            <div class="account-row" (click)="logout()">
                <div class="row-left">
                    <div class="icon-box warn-bg">
                        <mat-icon color="warn">logout</mat-icon>
                    </div>
                    <span>Logout</span>
                </div>
                <mat-icon>chevron_right</mat-icon>
            </div>

            <div class="account-row delete-row" (click)="deleteAccount()">
                <div class="row-left">
                    <div class="icon-box danger-bg">
                        <mat-icon class="danger-icon">delete_forever</mat-icon>
                    </div>
                    <span class="danger-text">Delete Account</span>
                </div>
                <mat-icon class="danger-icon">chevron_right</mat-icon>
            </div>
        </mat-card-content>
    </mat-card>
</div>